import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils';

/**
 * Badge — small label with variants for status, semantic colors.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-2xs font-medium uppercase tracking-wide',
  {
    variants: {
      variant: {
        default: 'bg-surface-2 text-fg-muted border border-border',
        brand: 'bg-brand/10 text-brand border border-brand/20',
        success: 'bg-success/10 text-success border border-success/20',
        warning: 'bg-warning/10 text-warning border border-warning/20',
        destructive: 'bg-destructive/10 text-destructive border border-destructive/20',
        info: 'bg-info/10 text-info border border-info/20',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

export function Badge({ className, variant, children, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {children}
    </span>
  );
}

/**
 * Dot — tiny status indicator with pulse animation for "live" states.
 */
export function Dot({ variant = 'brand', pulse = false, className }) {
  const colors = {
    brand: 'bg-brand',
    success: 'bg-success',
    warning: 'bg-warning',
    destructive: 'bg-destructive',
    info: 'bg-info',
  };
  return (
    <span
      className={cn(
        'inline-block h-1.5 w-1.5 rounded-full',
        colors[variant],
        pulse && 'pulse-live',
        className
      )}
    />
  );
}